import DotPattern from "@/components/dot-pattern";
import DilemmaTranslationForm from "@/features/dilemmas/components/forms/dilemma-translation-form";
import { useFetchDilemma } from "@/features/dilemmas/hooks/useFetchDilemma";
import { Skeleton } from "@/components/ui/skeleton";
import { useParams } from "react-router-dom";
import { useDynamicPageTitle } from "@/hooks";

const DilemmaTranslatePage = () => {
  const { id } = useParams();
  const { dilemma, isLoading } = useFetchDilemma(id);
  useDynamicPageTitle(dilemma ? `${dilemma.reference}` : "");

  return (
    <div className="relative flex flex-col lg:flex-row gap-3 lg:gap-5 p-3 lg:p-6">
      <DotPattern />
      {isLoading && (
        <div className="flex flex-col gap-3 w-full">
          <Skeleton className="w-48 h-8" />
          <Skeleton className="flex-1 h-96" />
        </div>
      )}
      {dilemma && !isLoading && <DilemmaTranslationForm dilemma={dilemma} />}
    </div>
  );
};

export default DilemmaTranslatePage;
